export enum CityNameId {
  ID = 'id',
  NAME_EN = 'nameEn',
  NAME_AR = 'nameAr',
  COUNTRY_ISO3 = "countryISO3letter",
  COUNTRY = 'country',
  CREATED_AT = 'createdAt',
}
